import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  passengerInformation: [
    // intialize with at least one passenger in slice
    {
      // passenger details
      firstName: "",
      secondName: "",
      title: "",
      assistance: "",
      referenceNumber: "",
      dueTime: "",
      prmBio: "",

      // request details
      originAssistance: true,
      destinationAssistance: true,
      airlineConfirmed: false,

      // equipment
      equipment: false,
      make: "",
      model: "",
      weight: "",
      battery: "",
      width: "",
      height: "",

      // form errors
      errors: []
    },
  ],
  flightInformation: {
    carrierCode: "",
    flightNumber: "",
    flightDepartureDate: "",
    flightType: "",
    errors: [],
  },
  status: 'idle',
  error: null
};

const bookingFormSlice = createSlice({
  name: 'bookingForm',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setBookingForm: (state, action) => {
      return {
        ...state,
        passengerInformation: action.payload
      }
    },
    setFlightInformation: (state, action) => {
      return {
        ...state,
        flightInformation: action.payload,
      }
    },
    resetPassengerInformation: (state, action) => {
      return {
        ...state,
        passengerInformation: []
      }
    },
    resetBookingFormErrors: (state, action) => {
      return {
        ...state,
        passengerInformation: state.passengerInformation.map((passenger) => {
          return {
            ...passenger,
            errors: []
          }
        })
      }
    }
  },
  extraReducers: {

  }
});

export const { reset, setBookingForm, resetPassengerInformation, updateAdditionalPassengers, setFlightInformation, resetBookingFormErrors } = bookingFormSlice.actions;
export const selectBookingForm = state => state.bookingForm.passengerInformation;
export const selectFlightInformation = state => state.bookingForm.flightInformation;
export const selectBookingFormStatus = state => state.bookingForm.status;

export default bookingFormSlice.reducer;
